import React from 'react';

const LoadingSpinner = ({ size = 'medium', className = '' }) => {
  const sizeClasses = {
    small: 'w-4 h-4',
    medium: 'w-6 h-6', 
    large: 'w-8 h-8'
  };

  return (
    <div className={`inline-flex items-center justify-center ${className}`}>
      <div className={`
        ${sizeClasses[size]}
        border-2 border-current border-t-transparent
        rounded-full animate-spin
        opacity-70
      `} />
    </div>
  );
};

export default LoadingSpinner;